const lazyImages = document.querySelectorAll('.lazyload');

const initLazyload = async () => {
  await import(/* webpackChunkName: "a-image--lazysizes" */ 'lazysizes');
  window.lazySizes.cfg.loadHidden = false;
};

if (lazyImages.length) initLazyload();
